import { buildRpaDomainSeoBundle } from "../rpaSeoUtils";

export const EDUCATION_DOMAIN_INTRO = {
  title: "Education",
  content: "Document AI + RPA and workflow automation across Examinations, Higher Education, Education Administration. Each use case includes challenge and solution detail, process diagrams, and human-in-the-loop review for enterprises in India, UAE, KSA, UK, and USA.",
  seoDescription: "Education automation use cases — document AI + RPA and workflow automation across Examinations, Higher Education, Education Administration. Validation, approvals, system updates, and exception handling.",
};

const slugify = (label) =>
  label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) {
  return {
    ...uc,
    groupId: slugify(uc.subIndustry),
    seoTitle: uc.title,
    title: uc.shortTitle || uc.title,
    systems: uc.systems || SYSTEMS,
  };
}

const SYSTEMS = "LMS, SIS, CRM, Email, Portal, Power BI";

const RAW = [
  {
    id: "hall-ticket-and-exam-eligibility-automation",
    subIndustry: "Examinations",
    department: "Exam Office",
    businessProcess: "Hall ticket and exam eligibility automation",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Hall ticket and exam eligibility automation",
    title: "Hall Ticket And Exam Eligibility Automation Automation for Education",
    seoKeywords: "education, hall ticket and exam eligibility automation, AI automation, RPA, agentic AI",
    challenge: "Exam teams manually verify attendance, fee status and forms before issuing hall tickets.",
    solution: "Implement RPA + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "RPA + Workflow Automation",
    buyerPersona: "Controller of Examinations",
    systems: "SIS, Exam System, ERP, Email",
    agentsRequired: "RPA Posting Agent, Hall Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and hall ticket and exam eligibility automation process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for hall ticket and exam eligibility automation",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "High",
  },
  {
    id: "certificate-and-transcript-issuance",
    subIndustry: "Higher Education",
    department: "Registrar",
    businessProcess: "Certificate and transcript issuance",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Certificate and transcript issuance",
    title: "Certificate And Transcript Issuance Automation for Education",
    seoKeywords: "education, certificate and transcript issuance, AI automation, RPA, agentic AI, document AI",
    challenge: "Transcript requests are manually validated, prepared and tracked.",
    solution: "Implement Document AI + RPA to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "Document AI + RPA",
    buyerPersona: "Registrar, CIO",
    systems: "SIS, DMS, Payment Gateway, Email",
    agentsRequired: "Document Extraction Agent, Certificate Validation Agent, Exception Agent",
    inputData: "Forms, PDFs, emails, scanned documents, attachments, master data and certificate and transcript issuance rules",
    outputActions: "Extracted structured data, validation results, exception list and approval-ready certificate and transcript issuance record",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "3-6 months",
    implementationComplexity: "Medium",
    businessImpact: "Medium",
  },
  {
    id: "library-inventory-and-overdue-notices",
    subIndustry: "Education Administration",
    department: "Library",
    businessProcess: "Library inventory and overdue notices",
    regions: "India, UAE/Dubai, KSA/Saudi Arabia, UK, USA",
    shortTitle: "Library inventory and overdue notices",
    title: "Library Inventory And Overdue Notices Automation for Education",
    seoKeywords: "education, library inventory and overdue notices, AI automation, RPA, agentic AI",
    challenge: "Book issues, returns and overdue notices require manual follow-up.",
    solution: "Implement RPA + Workflow Automation to capture inputs, validate rules, route exceptions, generate summaries or actions, and update the target systems with human approval where required.",
    automationType: "RPA + Workflow Automation",
    buyerPersona: "Library Head",
    systems: "Library Management System, SIS, Email, SMS",
    agentsRequired: "RPA Posting Agent, Library Validation Agent, Exception Agent",
    inputData: "Emails, forms, system records, task notes, master data and library inventory and overdue notices process rules",
    outputActions: "Validated workflow record, task assignment, status update and exception report for library inventory and overdue notices",
    keyBenefits: "Faster Turnaround, Lower Manual Effort, Improved Accuracy And Better Operational Visibility",
    roiTimeline: "0-3 months",
    implementationComplexity: "Low",
    businessImpact: "Low",
  },
];
export const EDUCATION_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Examinations", "Higher Education", "Education Administration"];
export const EDUCATION_GROUPS = GROUP_ORDER.map((label) => ({
  id: slugify(label),
  label,
})).filter((g) => EDUCATION_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildRpaDomainSeoBundle({
  domainSlug: 'education-domain',
  domainIntro: EDUCATION_DOMAIN_INTRO,
  useCases: EDUCATION_USE_CASES,
});
export const EDUCATION_USE_CASES_SEO = seo.useCasesSeo;
export const EDUCATION_DOMAIN_FAQS = seo.domainFaqs;
export const EDUCATION_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const EDUCATION_FAQ_JSONLD = seo.faqJsonLd;
export const EDUCATION_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const EDUCATION_WEBPAGE_JSONLD = seo.webPageJsonLd;

